export default __webpack_public_path__ + "static/media/Miscellaneous05.575399b2.jpg";